import { makeAutoObservable } from 'mobx'
import { openApi } from "../../../helpers/request"
import { WeekScheduleRow } from "../../../components/WeekScheduleEditor"

// Если для склада не задано ни одной строки — при проверке графика используется
// глобальный (см. Options-раздел "График приёма заказов").
class WarehouseScheduleController {

  list: any[] = []
  preorders: Record<number, boolean | null> = {}
  render: boolean = false

  constructor() {
    makeAutoObservable(this)
  }

  get() {
    return openApi('get', '/warehouse_order_schedule')
      .then((result: any) => {
        this.list = result.data.schedules
        this.preorders = result.data.preorders
        this.render = true
      })
      .catch(error => console.log(error.response))
  }

  rowsFor(warehouseId: number): WeekScheduleRow[] {
    return this.list
      .filter((row: any) => row.warehouse_id === warehouseId)
      .map((row: any) => ({ day: row.day, time_start: row.time_start, time_end: row.time_end }))
  }

  // null = наследовать глобальную настройку "Принимать предзаказы"
  preordersFor(warehouseId: number): boolean | null {
    const value = this.preorders[warehouseId]
    return value === undefined ? null : value
  }

  save(warehouseId: number, rows: WeekScheduleRow[], allowPreorders: boolean | null) {
    const data = new FormData()
    data.append('warehouse_id', `${warehouseId}`)
    data.append('rows', JSON.stringify(rows))
    data.append('allow_preorders', allowPreorders === null ? 'null' : (allowPreorders ? '1' : '0'))

    return openApi('post', '/warehouse_order_schedule', data)
      .then(() => this.get())
  }
}

export default new WarehouseScheduleController()
